import { useState } from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import { LinkedText } from '../../../components/LinkedText';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const { t } = useLanguage();

  const faqs = [
    {
      en_q: 'Is MrCuci a legitimate and safe online casino for Malaysians?',
      bm_q: 'Adakah MrCuci kasino dalam talian yang sah dan selamat untuk rakyat Malaysia?',
      en_a: "Yes, absolutely. MrCuci is a fully licensed online casino using 256-bit SSL encryption. All player data and funds are fully protected. Games are independently audited for fairness, and we support FPX online banking system, MEPS, Digi, Hotlink, Touch n' Go eWallet, Grab Pay.",
      bm_a: "Ya, sudah pasti. MrCuci ialah kasino dalam talian berlesen sepenuhnya dengan penyulitan SSL 256-bit. Semua data pemain dan dana dilindungi sepenuhnya. Permainan diaudit secara bebas untuk keadilan, dan kami menyokong FPX online banking system, MEPS, Digi, Hotlink, Touch n' Go eWallet, Grab Pay.",
    },
    {
      en_q: 'What bonus promotions can players claim at MrCuci?',
      bm_q: 'Apakah promosi bonus yang boleh dituntut pemain di MrCuci?',
      en_a: 'MrCuci currently offers four active promotions: New Member Register Free RM88 (no deposit, 1 claim per member ID), Welcome Bonus 50% on your first deposit from RM1, Deposit RM200 Free RM200 (once per day, ×10 turnover, max withdraw RM200), and Monthly Competition Deposit Ranking RM1088, a monthly deposit ranking with the top prize up to RM1,088 cash. Register, verify your account, and follow the promotion terms on the Bonus page to activate each offer.',
      bm_a: 'MrCuci kini menawarkan empat promosi aktif: Ahli Baharu Daftar Percuma RM88 (tiada deposit, 1 tuntutan setiap ID ahli), Bonus Selamat Datang 50% pada deposit pertama dari RM1, Deposit RM200 Percuma RM200 (sekali sehari, turnover ×10, max cuci RM200), dan Pertandingan Bulanan Kedudukan Deposit RM1088, kedudukan deposit bulanan dengan hadiah utama sehingga RM1,088 tunai. Daftar, sahkan akaun anda, dan ikut terma promosi di halaman Bonus untuk aktifkan setiap tawaran.',
    },
    {
      en_q: 'What Malaysian payment methods does MrCuci accept?',
      bm_q: 'Kaedah pembayaran Malaysia apakah yang diterima MrCuci?',
      en_a: "MrCuci supports FPX online banking system, MEPS, Digi, Hotlink, Touch n' Go eWallet, Grab Pay. Minimum deposit starts from RM10, and all transactions are processed securely with no hidden charges.",
      bm_a: "MrCuci menyokong FPX online banking system, MEPS, Digi, Hotlink, Touch n' Go eWallet, Grab Pay. Deposit minimum bermula dari RM10, dan semua transaksi diproses secara selamat tanpa caj tersembunyi.",
    },
    {
      en_q: 'How fast are withdrawals at MrCuci?',
      bm_q: 'Berapa cepat pengeluaran di MrCuci?',
      en_a: 'Standard withdrawals are processed within 5-15 minutes directly to your Malaysian bank account. VIP members receive same-day or instant payouts. Minimum withdrawal is only RM50 with absolutely zero fees charged by MrCuci. Touch \'n Go and e-wallet withdrawals are often instant.',
      bm_a: 'Pengeluaran standard diproses dalam masa 5-15 minit terus ke akaun bank Malaysia anda. Ahli VIP menerima bayaran pada hari yang sama atau segera. Pengeluaran minimum hanya RM50 dengan tiada yuran langsung oleh MrCuci. Pengeluaran Touch \'n Go dan e-dompet sering kali segera.',
    },
    {
      en_q: 'Can I play MrCuci on my Malaysian smartphone?',
      bm_q: 'Bolehkah saya bermain MrCuci pada telefon pintar Malaysia saya?',
      en_a: 'Yes! MrCuci is fully optimised for all popular smartphones in Malaysia, iPhone, Samsung, Xiaomi, Huawei, Oppo, and Vivo. Works on all Malaysian networks: Unifi, TIME, Maxis, Celcom, and Digi. No app download required, just open your mobile browser and play instantly.',
      bm_a: 'Ya! MrCuci dioptimumkan sepenuhnya untuk semua telefon pintar popular di Malaysia, iPhone, Samsung, Xiaomi, Huawei, Oppo, dan Vivo. Berfungsi pada semua rangkaian Malaysia: Unifi, TIME, Maxis, Celcom, dan Digi. Tiada muat turun aplikasi diperlukan, buka sahaja pelayar mudah alih anda dan main dengan segera.',
    },
    {
      en_q: 'Is customer support available in Bahasa Malaysia?',
      bm_q: 'Adakah sokongan pelanggan tersedia dalam Bahasa Malaysia?',
      en_a: 'Yes! Our customer support team includes fluent Bahasa Malaysia speakers available 24/7 via live chat, WhatsApp, Telegram, and email. We understand that Malaysian players prefer to communicate in their native language, so we\'ve built a fully bilingual support experience.',
      bm_a: 'Ya! Pasukan sokongan pelanggan kami termasuk penutur Bahasa Malaysia yang fasih, tersedia 24/7 melalui sembang langsung, WhatsApp, Telegram, dan e-mel. Kami faham pemain Malaysia lebih suka berkomunikasi dalam bahasa ibunda mereka, jadi kami telah membina pengalaman sokongan dwibahasa sepenuhnya.',
    },
    {
      en_q: 'What games are available at MrCuci Malaysia?',
      bm_q: 'Apakah permainan yang tersedia di MrCuci Malaysia?',
      en_a: 'MrCuci offers 5,000+ games including slots, fishing games, and live dealer tables such as Baccarat, Roulette, Blackjack, and Dragon Tiger. Key providers include Jili, VPower, MegaH5, Rich Gaming, WF Gaming, SCR888 H5, Epic Gaming, ACE333, Joker, 918Kiss, UU Slot, Live22, Pegasus, Playtech, Micrograming, and Pragmatic Play.',
      bm_a: 'MrCuci menawarkan 5,000+ permainan termasuk slot, permainan memancing, dan meja peniaga langsung seperti Baccarat, Roulette, Blackjack, dan Dragon Tiger. Penyedia utama termasuk Jili, VPower, MegaH5, Rich Gaming, WF Gaming, SCR888 H5, Epic Gaming, ACE333, Joker, 918Kiss, UU Slot, Live22, Pegasus, Playtech, Micrograming, dan Pragmatic Play.',
    },
    {
      en_q: 'Does MrCuci support responsible gambling for Malaysians?',
      bm_q: 'Adakah MrCuci menyokong perjudian yang bertanggungjawab untuk rakyat Malaysia?',
      en_a: 'Yes. MrCuci provides comprehensive responsible gambling tools including deposit limits, loss limits, session time limits, self-exclusion options, and reality check reminders, all available in Bahasa Malaysia. We are committed to promoting safe gaming among all Malaysian players.',
      bm_a: 'Ya. MrCuci menyediakan alat perjudian bertanggungjawab yang komprehensif termasuk had deposit, had kerugian, had masa sesi, pilihan pengecualian diri, dan peringatan semak realiti, semuanya tersedia dalam Bahasa Malaysia. Kami komited untuk mempromosikan permainan selamat di kalangan semua pemain Malaysia.',
    },
  ];

  return (
    <section
      id="frequently-asked-questions"
      style={{ background: 'linear-gradient(135deg, #0d0101 0%, #130202 100%)' }}
      className="py-16 md:py-24"
    >
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 bg-[#cc1100]/15 border border-[#cc1100]/30 rounded-full px-4 py-1.5 mb-4">
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-question-line text-[#d4a017] text-xs" />
            </span>
            <span className="text-[#d4a017] text-xs font-semibold tracking-widest uppercase">FAQ</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4">
            {t('Frequently Asked', 'Soalan Yang Sering')}{' '}
            <span
              className="text-transparent bg-clip-text"
              style={{ backgroundImage: 'linear-gradient(135deg, #cc1100, #d4a017)' }}
            >
              {t('Questions', 'Ditanya')}
            </span>
          </h2>
          <p className="text-gray-400 text-sm leading-relaxed max-w-2xl mx-auto">
            <LinkedText>{t(
              'Got questions about MrCuci Malaysia? Find answers below. Our 24/7 Malay-speaking support team is always ready to help.',
              'Ada soalan tentang MrCuci Malaysia? Cari jawapan di bawah. Pasukan sokongan berbahasa Melayu 24/7 kami sentiasa bersedia untuk membantu.'
            )}</LinkedText>
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-xl overflow-hidden transition-all duration-300"
              style={{
                background: openIndex === idx ? 'linear-gradient(135deg, #200404, #2a0606)' : 'linear-gradient(135deg, #180303, #1e0404)',
                border: openIndex === idx ? '1px solid rgba(212,160,23,0.35)' : '1px solid rgba(204,17,0,0.15)',
              }}
            >
              <button
                className="w-full flex items-center justify-between px-4 md:px-5 py-4 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
              >
                <div className="flex items-center gap-3 pr-4">
                  <span
                    className="w-6 h-6 flex items-center justify-center rounded-md text-xs font-black shrink-0"
                    style={{ background: openIndex === idx ? 'linear-gradient(135deg, #d4a017, #f5c518)' : 'rgba(204,17,0,0.3)', color: openIndex === idx ? 'black' : '#d4a017' }}
                  >
                    {idx + 1}
                  </span>
                  <h4 className={`text-sm font-bold ${openIndex === idx ? 'text-[#d4a017]' : 'text-white'}`}>
                    {t(faq.en_q, faq.bm_q)}
                  </h4>
                </div>
                <span className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className={`ri-arrow-down-s-line text-[#d4a017] text-lg transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`} />
                </span>
              </button>
              {openIndex === idx && (
                <div className="px-4 md:px-5 pb-5">
                  <div className="pl-9">
                    <p className="text-gray-400 text-sm leading-relaxed"><LinkedText>{t(faq.en_a, faq.bm_a)}</LinkedText></p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Support CTA */}
        <div
          className="mt-8 md:mt-10 rounded-xl p-5 md:p-6 flex flex-col sm:flex-row items-center justify-between gap-4"
          style={{ background: 'linear-gradient(135deg, #1e0404, #250505)', border: '1px solid rgba(212,160,23,0.2)' }}
        >
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center rounded-full shrink-0"
              style={{ background: 'linear-gradient(135deg, #cc1100, #d4a017)' }}>
              <i className="ri-customer-service-2-line text-black text-lg" />
            </div>
            <div>
              <p className="text-white font-bold text-sm">{t('Still have questions?', 'Masih ada soalan?')}</p>
              <p className="text-gray-500 text-xs">{t('Our Malay-speaking support team is online 24/7.', 'Pasukan sokongan berbahasa Melayu kami dalam talian 24/7.')}</p>
            </div>
          </div>
          <a
            href="https://mrcuci.org/chatroom"
            className="inline-flex items-center gap-2 font-bold px-6 py-2.5 rounded-lg hover:opacity-90 transition-all whitespace-nowrap cursor-pointer text-sm shrink-0 text-black"
            style={{ background: 'linear-gradient(135deg, #cc1100, #d4a017)' }}
          >
            <span>{t('Chat With Us', 'Sembang Dengan Kami')}</span>
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-chat-3-line" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
